import React from 'react';

// Define the stages of the conversion funnel // eslint-disable-next-line react-refresh/only-export-components
export enum FunnelStage {
  AWARENESS = 'awareness',
  INTEREST = 'interest',
  CONSIDERATION = 'consideration',
  INTENT = 'intent',
  EVALUATION = 'evaluation',
  PURCHASE = 'purchase',
}

// Create a context for the funnel
export interface FunnelContextType {
  currentStage: FunnelStage;
  advanceStage: (nextStage: FunnelStage, additionalData?: Record<string, unknown>) => void;
  trackConversion: (
    conversionName: string,
    value?: number,
    additionalData?: Record<string, unknown>
  ) => Record<string, unknown>;
  funnelData: Record<string, unknown>;
}

export const FunnelContext = React.createContext<FunnelContextType | undefined>(undefined);

// Custom hook to use the funnel context ; eslint-disable-next-line react-refresh/only-export-components
export const useFunnel = (): FunnelContextType => {
  const context = React.useContext(FunnelContext);
  if (!context) {
    throw new Error('useFunnel must be used within a ConversionFunnel component');
  }
  return context;
};
